// extracted by mini-css-extract-plugin
export default {"actions-column":"crud-table_actions-column__BvcLf","actions-column-flex":"crud-table_actions-column-flex__f9RHq","actions-button":"crud-table_actions-button__EAKXk"};